import {LANGUAGE_STORAGE_KEY} from 'constants/storageKeys'

export function getLastKnownLanguage() {
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
}

export function setLastKnownLanguage(value) {
    return window.localStorage.setItem(LANGUAGE_STORAGE_KEY, value)
}